import '../styles/app';
import "@fortawesome/fontawesome-free/js/fontawesome"

window.addEventListener('load', () => {
  console.log('App loaded');
  
  // My-Calendar Patch

  const setupIcons = () => {
    if(document.querySelector(".mc-main")) {
      let chevronNext =  document.querySelector(".my-calendar-next a");
      let chevronPrev =  document.querySelector(".my-calendar-prev a");
      let closeCrosses = document.querySelectorAll(".dashicons-dismiss");

      // chevrons
      if(chevronNext && !chevronNext.querySelector("span")) {
        let chevron = document.createElement("span")
        chevron.classList.add("fas", "fa-chevron-right")
        chevronNext.append(chevron)
      }

      if(chevronPrev && !chevronPrev.querySelector("span")) {
        let chevron = document.createElement("span")
        chevron.classList.add("fas", "fa-chevron-left")
        chevronPrev.append(chevron)
      }

      closeCrosses.forEach(cross => {
        cross.classList.remove("dashicons", "dashicons-dismiss")
        cross.classList.add("fas", "fa-times")
      });
    }
  }

  if(document.querySelector(".mc-main")) {

    // use a mutation observer to trigger setupIcons when
    // change view of month
    
   // Select the node that will be observed for mutations
    const targetNode = document.querySelector('.mc-main');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for(let mutation of mutationsList) {
            if (mutation.type === 'attributes') {
              setupIcons()
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

  setupIcons();

})
